import { cx } from 'linaria';
import React, { forwardRef } from 'react';

import { useComponents } from '../component-provider';
import { default as IconChevronRight } from '../../../icons/12px/chevron-right.svg';
import { Typography } from '../index';
import * as styles from './breadcrumb-item.styles';
import { BreadcrumbsContext } from './breadcrumbs.context';

interface BreadcrumbItemProps extends React.AllHTMLAttributes<HTMLElement> {
    to: string;
}

export const BreadcrumbsItem = forwardRef<HTMLLIElement, BreadcrumbItemProps>((props, ref) => {
    const { children, className: classNameProp, to, ...passThroughProps } = props;
    const className = cx(styles.root, classNameProp);

    const { Link } = useComponents();
    const { isCurrent } = React.useContext(BreadcrumbsContext);

    const linkProp = isCurrent ? {} : Link.displayName === 'DefaultLink' ? { href: to } : { to };
    const LinkComponent = isCurrent ? 'a' : Link;

    const preventDefault = (event: React.SyntheticEvent) => event.preventDefault();

    return (
        <li ref={ref} className={className} {...passThroughProps}>
            {
                <Typography variant={isCurrent ? 'label-2' : 'caption-1'} as="span">
                    <LinkComponent
                        {...linkProp}
                        className={cx(styles.text, isCurrent && styles.current)}
                        aria-current={isCurrent ? 'page' : null}
                        onClick={isCurrent ? preventDefault : null}
                    >
                        {children}
                    </LinkComponent>
                </Typography>
            }
            {isCurrent ? null : (
                <div aria-hidden="true" className={cx(styles.separator)}>
                    <IconChevronRight className={styles.separatorIcon} />
                </div>
            )}
        </li>
    );
});

BreadcrumbsItem.displayName = 'BreadcrumbsItem';
